import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { showToast } from "..";
import { sitesSerivces, actifsService, classeursService } from "../../services";
import { ArborescenceBâtimentaireV3 } from "../actif_arborescence/ArborescenceBâtimentaire";
import { Actif, Classeur, Site } from "../../interfaces";
import { useQueryClient } from "@tanstack/react-query";
import { MultiSelect } from "primereact/multiselect";
import { TabView, TabPanel } from 'primereact/tabview';
import { array, number } from "prop-types";
import { useAuth } from "../../utils/UserProvider";
 
interface FormCorrespondanceClasseurProps {
  closeModalCorrespondance?: () => void;
  addedClasseur: Classeur;
  setLoading: (newvalue: boolean) => void;
}
const FormCorrespondanceClasseur = ({
  closeModalCorrespondance,
  addedClasseur,
  setLoading,
}: FormCorrespondanceClasseurProps) => {
  const queryClient = useQueryClient();
 
  const [selectedSite, setSelectedSite] = useState<Site[] | null>(null);
  const [selectedActif, setSelectedActif] = useState<Actif | null>(null);
  const [selectedActifs, setSelectedActifs] = useState<Actif[] | null>(null);
  const [selectedBâtiments, setSelectedBâtiments] = useState([]);
  const [selectedNiveaux, setSelectedNiveaux] = useState([]);
  const [selectedEspaces, setSelectedEspaces] = useState([]);
  const [selectedPieces, setSelectedPieces] = useState([]);
  const [selectedActifIds, setSelectedActifIds] = useState([]);
  const [selectedsiteIds, setSelectedsiteIds] = useState([]);
  const [sites, setSites] = useState<Site[]>([]);
  const [actifs, setActifs] = useState<Actif[]>([]);
  const { user, client } = useAuth();
  

  const [activeActifId, setActiveActifId] = useState(0);
 

const handleTabChange = (e) => {
    setActiveActifId(e.index);
    
};




  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
 
 
  useEffect(() => {
    const fetchSitesAPI = async () => {
      try {
        setLoading(true);
        const response = await sitesSerivces.getAll(client?.id);
        setSites(response);
        setLoading(false);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };
    fetchSitesAPI();
  }, []);
 
  useEffect(() => {
    const FetchActifs = async (site_id) => {
      try {
        setLoading(true);
        const response = await actifsService.getActifsBySite(site_id);
        setSelectedsiteIds((prevsites) => Array.from(new Set([...prevsites, site_id])));
        setActifs((prevActifs) => {
          const merged = [...prevActifs, ...response];
          
          
          const uniqueActifs = Array.from(
            new Map(merged.map((item) => [item.id, item])).values()
          );
        
          return uniqueActifs;
        });
  
        setLoading(false);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };
    if (sites?.length > 0) {
      sites?.map((site) =>{
         FetchActifs(site?.id);
      });
    }
  }, [sites]);
 
 
 
const selectSite = async (site_id) => {
  try {
    setLoading(true);
    const response = await sitesSerivces.getById(site_id);
    setSelectedSite(response);
    setLoading(false);
  } catch (e) {
    console.log("Error while fetching", e);
  }
};
 
 
 
 
  /*const selectActif = async (actif_id) => {
    try {
      setLoading(true);
      const response = await actifsService.getById(actif_id);
      setSelectedActif(response);
      setLoading(false);
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };*/
 
  const onSubmit = async (data) => {
    try {
      const Data = {
        classeur_id: addedClasseur.id,
        actif_id: selectedActifIds,
        site_id: selectedsiteIds[0],
        batiment_ids: selectedBâtiments,
        niveau_ids: selectedNiveaux,
        espace_ids: selectedEspaces,
        piece_ids: selectedPieces,
      };
     
      setLoading(true);
      await classeursService.correspondanceClasseur(Data).then((response) => {
        setLoading(false);
        showToast(
          "success",
          "Correspondance bâtimentaire effectué avec succès"
        );
        
        queryClient.refetchQueries({
          queryKey: ["classeurs"],
        });
 
        reset();
        closeModalCorrespondance();
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };
 
 
 
  const itemTemplate = (option) => {
    return (
      <div>
        {
          <span>{`${option.nom_actif} `}</span>
         }
      </div>
    );
  };
 
  useEffect(() => {
    if (selectedActifs) {
      setSelectedActif(selectedActifs[0]);
    }
  }, [selectedActifs]);

 
 
  useEffect(() => {
    if (selectedActifs && selectedActifs.length > 0) {
      const actifIds = selectedActifs.map((actif) => actif.id);
      setSelectedActifIds(actifIds);
    }
  }, [selectedActifs]);
  
 

 
 
  return (
    <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
      
      {actifs.length != 0 ? (
        <div className="col-span-6 sm:col-span-6">
          <label
            htmlFor="actif_id"
            className="text-gray-900 font-bold  "
          >
            Choisissez vos actifs :
          </label>
 
          <MultiSelect
                        itemTemplate={itemTemplate}
                        value={selectedActifs}
                        options={actifs}
                        onChange={(e) => {
                          if (e.value.length <= 3) {
                            setSelectedActifs(e.value); // Allow selection if under the limit
                          }
                        }}
                        optionLabel="nom_actif"
                        placeholder="Sélectionner un ou plusieurs actifs"
                        className="h-12 my-3 border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 w-full"
                        filter
                        showClear
                        display="chip"
                       
 
                      />
        </div>
      ) : (
        <div
          className="p-4 mb-4 col-span-6 sm:col-span-6 text-sm text-blue-800 rounded-lg bg-blue-50 "
          role="alert"
        >
          <span className="font-bold text-lg">
            Pas d'actif disponible pour ce site
          </span>
        </div>
      )}
      
      <h3 className="text-gray-900 font-bold ">
        Arborescence bâtimentaire des actifs sélectionnés :
      </h3>
   
      
      <TabView activeIndex={activeActifId} onTabChange={handleTabChange}>
        {selectedActifs && (
          selectedActifs.map((actif) => (
            <TabPanel key={actif.id} header={actif?.nom_actif} >
             <div className="w-full max-h-96 overflow-auto space-y-4 mx-10 my-2">
              <ArborescenceBâtimentaireV3
                site={sites.find((site) => site.id === actif?.site_id)}
                actif={actif}
                checkbox={true}
                batimentIds={actif.bâtiments?.map((batiment) => batiment.id) || []}
                niveauIds={actif.niveaux?.map((niveau) => niveau.id) || []}
                espaceIds={actif.espaces?.map((espace) => espace.id) || []}
                pieceIds={actif.pieces?.map((piece) => piece.id) || []}
                setSelectedBâtiments={setSelectedBâtiments}
                setSelectedNiveaux={setSelectedNiveaux}
                setSelectedEspaces={setSelectedEspaces}
                setSelectedPieces={setSelectedPieces }
                selectedBâtiments={selectedBâtiments}
                selectedNiveaux={selectedNiveaux}
                selectedEspaces={selectedEspaces}
                selectedPieces={selectedPieces}
              />
              </div>
              
             
            </TabPanel>
            
        
           
          ))
        ) }
</TabView>

    
 
      <div className="flex justify-end space-x-2 mt-5">
      <button
        type="submit"
        className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-sm px-6 py-3  text-center "
        >
        Ajouter
      </button>
        <button
          type="button"
          onClick={() => {
            closeModalCorrespondance();
            reset();
            setSelectedSite(null);
            setSelectedActif(null);
          }}
          className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-3  text-center "
        >
          Annuler
        </button>
      </div>
    </form>
  );
};
 
export default FormCorrespondanceClasseur;